/* lua.js generated code 0.3.1 */
let UserLevelTypeBase = require("clover/logic/userLevel/UserLevelTypeBase")
let UserLevelTypePvp = xClass("UserLevelTypePvp", UserLevelTypeBase)
UserLevelTypePvp.prototype.canStartLevel = function (levelId, itemList) {
    return [true]
}
UserLevelTypePvp.prototype.ctor = function (levelId, itemList) {
    let self = this
    UserLevelTypeBase.prototype.ctor.call(self, levelId, itemList)
    self.levelType = GameLevelType.kPvp
}
UserLevelTypePvp.prototype.getConsumeEnergy = function (levelId) {
    let self = this
    // body
    return 0
}
UserLevelTypePvp.prototype.startLevel = function (levelId, itemList, successCallback, failCallback, cancelCallback) {
    let self = this
    function onSuccess(event) {
        if (successCallback) {
            successCallback(event)
        }
    }
    onSuccess && onSuccess()
}
UserLevelTypePvp.prototype.canUseProp = function (propId, num) {
    // return [true]
    return [false]  // pvp不能用道具的
}
UserLevelTypePvp.prototype.endLevel = function () {
}
module.exports = UserLevelTypePvp